import React, { PureComponent } from 'react';
import ReactTooltip from 'react-tooltip';
import './tooltipInfo.scss';

interface Props {
  place?: 'top' | 'right' | 'bottom' | 'left' | undefined;
  id?: string;
}

class TooltipInfo extends PureComponent<Props> {
  private tooltipRef;

  static defaultProps = {
    place: 'top',
  };

  render() {
    const { place } = this.props;
    return (
      <div className='component-tooltip-info'>
        <ReactTooltip
          clickable
          effect='solid'
          place={place}
          type='info'
          delayShow={50}
          id={this.props.id}
          ref={(el) => {
            this.tooltipRef = el;
          }}
          getContent={(content) =>
            content ? (
              <div className='component-tooltip-info__inner'>{content}</div>
            ) : undefined
          }
          afterShow={() => {
            if (this.tooltipRef) {
              this.tooltipRef.updatePosition();
            }
          }}
        />
      </div>
    );
  }
}

export default TooltipInfo;
